export default __webpack_public_path__ + "static/marek_stawiasz_codeme-62d8d874a5e09cfcfaed42cb88447b64.png";